import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
import GoalEditForm from '../../elements/goals/form';
import Loading from './../../elements/loading';
import GoalsAdd from './../../elements/goals/widget/goals_add';

class GoalEdit extends Component {
	render() {
		const { goals} = this.props;
		return (
			goals.isFetching ? <Loading/>:<GoalEditForm {...this.props} />
		)
	}

	componentWillMount() {
		this.props.resetGoalActivities();
		this.props.fetchGoalComplete(this.props.match.params.id);
	}
}

export default BaseLayout(GoalEdit, {
	title:"Editar Meta",
	subnav: {
		icon: 'fa-flag-checkered',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <GoalsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/goals/edit.jsx